import { render, staticRenderFns } from "./PelleGalaxyGeneratorPanel.vue?vue&type=template&id=6db9a0ba&scoped=true&"
import script from "./PelleGalaxyGeneratorPanel.vue?vue&type=script&lang=js&"
export * from "./PelleGalaxyGeneratorPanel.vue?vue&type=script&lang=js&"
import style0 from "./PelleGalaxyGeneratorPanel.vue?vue&type=style&index=0&id=6db9a0ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db9a0ba",
  null
  
)

export default component.exports